var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHazardousFaceBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.6,
    height: 30.6,
    viewBox: "0 0 30.6 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hazardous_icon",
    "data-name": "Hazardous icon",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M468,388h14.359a.141.141,0,0,1,.141.141V402.5A14.5,14.5,0,0,1,468,417h0a14.5,14.5,0,0,1-14.5-14.5h0A14.5,14.5,0,0,1,468,388Z",
    transform: "translate(-453.5 -388)",
    fill: "none",
    stroke: "#030504",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(6.089 5.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M471.718,417.091a3.718,3.718,0,1,1,3.718-3.718A3.722,3.722,0,0,1,471.718,417.091Zm0-5.949a2.231,2.231,0,1,0,2.231,2.231A2.233,2.233,0,0,0,471.718,411.142Z",
    transform: "translate(-463.307 -399.014)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 7.577,
    height: 1.487,
    transform: "translate(0.002 5.358) rotate(-45)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 1.487,
    height: 7.577,
    transform: "translate(0 1.052) rotate(-45.002)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 7.579,
    height: 1.487,
    transform: "translate(10.41 5.359) rotate(-45)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 1.487,
    height: 7.579,
    transform: "translate(10.41 1.052) rotate(-45.004)",
    fill: "#030504",
    stroke: "#030504",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazardousFaceBlack);
export default __webpack_public_path__ + "static/media/hazardousFaceBlack.ace63f140fd160933d0f34e8c1d5b67a.svg";
export { ForwardRef as ReactComponent };